var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('loading-and-response-dialog',{attrs:{"element-props":_vm.$store.state.lard.loadingAndResponseDialog},on:{"on-error-click":_vm.onErrorClickInLARDialog,"on-success-click":_vm.onSuccessClickInLARDialog}}),_c(_vm.layout,{key:"normalLayout",tag:"component"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }